module.exports = __webpack_public_path__ + "fonts/antonio-regular-unhinted-webfont.cedde268.woff2";